export const releases = [
  {
    title: 'Persona',
    year: 2025,
    songs: [
      {
        title: 'Bite',
        lyrics: `That's the user of your body talking
You will never be oneness
I should only trust your gaze
Bite down on your fucking neck

Value-judgments won't survive
Your naked mind sitting beside me
You are most present when absent
Soul not random, not stochastic`,
        tabs: [],
      },
      {
        title: 'On Azure Pastures',
        lyrics: `On azure pastures my verdant mind rolls
Lunatic glitter lines all thought threads
In a gelid world is sangfroid born
Within suspended phantasmagoria we prance

And is it that everything could be
Not un-being from beingness between
A square assembly of a dozen cypresses
Only an enigma of wintry doggedness`,
        tabs: [],
      },
      {
        title: 'Pedagogy Of Dead Angles',
        lyrics: `I ground myself and turn my hips
You are a person when I see you flinch
Relentless pelting with pomegranates
As per the pedagogy of dead angles

Debar
Liquefy
Occupy
Indurate

Pounding at your inverted hide
I am unreal when you see me hit
Transient; baffling; elusive
Sway of distorted air diffusive

Debar
Liquefy
Occupy
Indurate`,
        tabs: [],
      },
      {
        title: 'Ought',
        lyrics: `Is is is is is is is is
Is is is is is is is
Is is is is is is
Is is is is is

Is is is is is
Is is is is is is
Is is is is is is is
Is is is is is is is is

Is is is is is is is is
Is is is is is is is
Is is is is is is
Is is is is is

Is is is is is
Is is is is is is
Is is is is is is is
Is is is is is is is is`,
        tabs: [],
      },
      {
        title: 'Metanoia',
        lyrics: `Twice-born clock wrapped in a void absurd
Still life of mind-consumed wretched minutes
As complacent as it was vivid
This disarray of yours an assortment of deaths

Persona exploded and reassembled
Gadarene configuration tempered
Runtime errors all snubbed and unhandled
A thermally toughened new idiot maintained

Once again tethered to a fresh shell fougasse
Time only still in a corner of green granite
Steelblue ladybugs rotate in place
New solace lies in the fate's odd creek

An expanse of scenery where a mind is born unsecured
You are most real and undefined
Conchoidal lies shimmer and play in red gold
Visit the pitiable enigma of desires

Everything is you and it is contained
Cast only light and devour a shore
Music up in a swell before commercial
And here is a scene from next week's gestalt`,
        tabs: [
          {
            url: '/files/Tegara_-_Metanoia_rhythm_guitar_tabs.pdf',
            desc: 'Rhythm guitar tabs',
          },
        ],
      },
      {
        title: 'Xylene Touch',
        lyrics: `Encasement in tetrahedral thought
Lobotomized reality on a spinning dais
Contemptible decalcomanias of pretension
Anywhen a xylene touch of restoration

Front is behind my static eyes
Strike an unresponsive chord contorted
Lest I be perturbed by bedrock
A chariot drawn by tigers flies me away

Eyeing askance at subatomic lies
Distill and bathe in aromatic axioms
Meant to be distorted and pulled apart
Calls for my prompt treatment the siccative framework

Uncreate
Mutilate
Dissolve
Resolve

How come time is a snap of my fingers
Divine and insane reality-impulse
Speak the truth of hypnagogic lies
Outside the interlaced frames around us

Travertine floor boundless in all directions
Brass lions and archs sprung from a bust
Open place forever contained in amber dusk
`,
        tabs: [
          {
            url: '/files/Tegara_-_Xylene_Touch_rhythm_guitar_tabs.pdf',
            desc: 'Rhythm guitar tabs',
          },
        ],
      },
      {
        title: 'Null Polarization',
        lyrics: null,
        tabs: [],
      },
    ],
    comments: `There is less focus on sleek clear-cut grooves and death metal sound is winning over from here on out.
    
    Persona was included in <a href='https://www.youtube.com/watch?v=VAb6Gkbm1ys target='_blank' rel='noreferrer'>Metal Trenches' Best New Underground Metal Albums</a> review of October 2025.`,
  },
  {
    title: 'Prodome',
    year: 2025,
    songs: [
      {
        title: 'Prodome',
        lyrics: `Just a cue to a break from jade gray
Reassembled bookshelves fall
Three fields over a fanfare sounds
Interlacing qualms materialize

No content
All that would and did take place
Paints each page vantablack
For agitation to erase them repeatedly

That's my unit; they're here for me
My disdain grows ever larger
Convalescence will not be
Rotating gravity torques my inner ears

Doused in battery-acid risen from empty words
Dividend or divisor, which one is the lie

No content

When prevarications cease corroding
I wake into an alkaline oleander

Going into the me below
Lose me in corporeal insanity pre-programmed
The pothole would rise to submerge me

I'm divided by the reciprocal of me
I squared is I — I am potential — I am all products
This insane firmware, the growling memory
I am the end-user of feverish static
`,
        tabs: [
          {
            url: '/files/Tegara_-_Prodome_rhythm_guitar_tabs.pdf',
            desc: 'Rhythm guitar tabs',
          },
          {
            url: '/files/Tegara_-_Prodome_trash_guitar_tabs.pdf',
            desc: 'Trash guitar tabs',
          },
        ],
      },
    ],
    comments: `Left as a single release.`,
  },
  {
    title: 'Threnodist',
    year: 2025,
    songs: [
      {
        title: 'Threnodist',
        lyrics: `Blessed is he who keeps pulling threads
A lamenter catching reflections from within
You, a seasoned sifu of requiems
The dirge master playing the largest violin

Abhorring de-opacifications
Commenced before the succession of realities
Ants saturating all configurations
Unflaggingly hiking on corpuscles

Over-easy eggs hanging from crutches
Overlooking inverted Monet skies
Would I like them boiled by the amplified noise floor
Should I consume the resurrection of Christ

The howling clouds gliding in our eyes
We know peace when they are restless
Mists sailing on staff, allegro
Playing the song of tristesse deathless

Tangent to my deeds, the conduct; my actions,
refulgent with viscosity
Swallowing into themselves,
pinioned motions continually enmeshed

To nullify the shrieking nothingness,
the successional blustering intervals
I drag weights of bedrocks with me
I bring together impossible walls

A suspended line, a tense fiber
Cutting through ether unbent
The ray of my soul, impartible
Accompanying one's deafening tranquil

Fuck you motherfucker and
let me perform a song of
mourning for you right now

The howling clouds gliding in our eyes
We know peace when they are restless
Mists sailing on staff, allegro`,
        tabs: [
          {
            url: '/files/Tegara_-_Threnodist_rhythm_guitar_tabs.pdf',
            desc: 'Rhythm guitar tabs',
          },
          {
            url: '/files/Tegara_-_Threnodist_lead_guitar_tabs.pdf',
            desc: 'Lead guitar tabs',
          },
        ],
      },
      {
        title: 'Avalanche',
        lyrics: `Ah, you see from below
You have welcomed yourself
Confluence only an animate fist knows
Misadventure that Shackleton envies

Inkling in advance of all
Have you ever seen the orchestra
Playing not on the mezzanine
But on the highest balcony

What privilege to have been succumbed
To a crescendo
Slabs of not turpitude
A stauchwall not of senseless wrath

Participation you will not abhor
Your haughty strides we ask to halt
You must observe well-deserved resplendence

I give credit where credit is due
You created fantastic incomprehensiveness
Here is a signature of Debasement
So your royalties will be paid in full

Amusing, rash crown fracture lines
Rushing to hasten an onslaught to ravage
No more evident can cause and effect be
In an inverted quietus space

I see from above
I have redeemed myself
Gremlins introduced to the outcrop
Imps subdued and squelched

The transient knows of substance
Halt and feel no more
Contemptuous impulse-latensification
Perfunctory smile of a static eum-yang `,
        tabs: [
          {
            url: '/files/Tegara_-_Avalanche_rhythm_guitar_tabs.pdf',
            desc: 'Rhythm guitar tabs',
          },
          {
            url: '/files/Tegara_-_Avalanche_solo_guitar_tabs.pdf',
            desc: 'Solo guitar tabs',
          },
        ],
      },
      {
        title: 'Enantiodromia',
        lyrics: `For it to have yielded and collapsed
For it to emerge as buried opposite
Now first inhibited and broken down
Here cathexis of forces into power

I observe, calculate and gaze upon
I do nothing and everything
Your jaw glimmers and rotates
Your eyes uncased but not looking

Your obvious, excessive commitment
To collective, masking ideals
Your persona a mere semblance
Explosion precedes individuation

Adornments we do not care for
Veils so false and insipid
Within confines of tighter limits
Your operose patching up miscarries

Speak
Weep
Screech
Heal

Pretend you are now what you were
You are the protagonist with a reputation
Negative restoration of your persona
A caricature now brought about

But dreaded for tactlessness
Trapped and blind to the world
A spectral Cassandra in disturbed state
This possibility could you endure?`,
        'Maze Exterior': `Why does one contain and comprehend
Do you restore and recreate
Inauthenticity within a maze
This role can you perform and live

Will it not collide with nor hide self
Can you readapt and develop
New and viable inside a tangle
Resurface with decompression sickness

Will it not collide
Can you readapt
New and viable
Resurface

Reinstatement initialized
Begin a transfiguration total
Decontamination of your network
A funeral pyre of all

Placid, compose, unshaken
Unperturbed, lubricated
Are you thinking yourself back
Are you executing impeccably

Keep throwing yourself forward
You are unfettered and unperturbed
Twist and turn intrinsic redshifts blue

Reality is what you're vitrified in
Pinioned while 'reborn' inside a catacomb
I am beside you and limber as the wicopy
You're an absent, extinguished core

Can you readapt
New and viable
Resurface

Why does one contain
Do you restore
Inauthenticity
You can not perform`,
        tabs: [
          {
            url: '/files/Tegara_-_Enantiodromia_rhythm_guitar_tabs.pdf',
            desc: 'Rhythm guitar tabs',
          },
        ],
      },
      {
        title: 'Maze Exterior',
        lyrics: `Why does one contain and comprehend
Do you restore and recreate
Inauthenticity within a maze
This role can you perform and live

Will it not collide with nor hide self
Can you readapt and develop
New and viable inside a tangle
Resurface with decompression sickness

Will it not collide
Can you readapt
New and viable
Resurface

Reinstatement initialized
Begin a transfiguration total
Decontamination of your network
A funeral pyre of all

Placid, compose, unshaken
Unperturbed, lubricated
Are you thinking yourself back
Are you executing impeccably

Keep throwing yourself forward
You are unfettered and unperturbed
Twist and turn intrinsic redshifts blue

Reality is what you're vitrified in
Pinioned while 'reborn' inside a catacomb
I am beside you and limber as the wicopy
You're an absent, extinguished core

Can you readapt
New and viable
Resurface

Why does one contain
Do you restore
Inauthenticity
You can not perform`,
        tabs: [
          {
            url: '/files/Tegara_-_Maze_Exterior_rhythm_guitar_tabs.pdf',
            desc: 'Rhythm guitar tabs',
          },
        ],
      },
      {
        title: 'Black Sky Sunbath',
        lyrics: `Suddenly the blue sky was pulled away
Enveloping iodine clock reaction
Shakes me to my core, melts my face
Terror-embracement not an aberration

The Sun screams at me naked
Blinded I am, yet it keeps blinding me
A thread of penance in me vibrated
Viscera manipulated by chordal chords within

Coruscating eyeballs inquire in fear
Stunned phantoms tune into nothing
Ionizing penalty at once imposed
On us within the governance of life king

Oh!

Conjunct motifs of regret and demise
Are forever contained, never progressing
Verily I say unto each of you
Scorching affright-melody with you you're taking

See your disintegration in real time
Wake up and observe your fall into ruin
Hear yourself become an interference pattern
Your constituents are repelling each other

An ill trick of fate
Can consequences be tied to actions
Do not deduce — brush everything off
Dismissal, just as futile and otiose

Regulations there are not!
What use are limitations in your final process
Who is judging you on your way out
Why shouldn't you prance around before death

Assaulting imagery of your kaleidoscope
Fades out when you figure out your surroundings
Doom-ostinatos stop dead in their tracks
Fear has been pushed out of the sweat glands
Curtains close on your emotions
Was there a lesson that survives the encore`,
        tabs: [
          {
            url: '/files/Tegara_-_Black_Sky_Sunbath_rhythm_guitar_tabs.pdf',
            desc: 'Rhythm guitar tabs',
          },
          {
            url: '/files/Tegara_-_Black_Sky_Sunbath_solo_guitar_tabs.pdf',
            desc: 'Solo guitar tabs',
          },
        ],
      },
      {
        title: 'Supermirage',
        lyrics: `My ears not free from green surf's roar
Innocent cascades of marred waves
Each iteration of me wandering here
The liminal walls brood just the same

Persistence of impressionist fair weather
Speaks to me of incandescent gloom
Quests with no purpose stringed together
Tied around a neck of arcanum

I am awake in the same place
Eyes peeled for dissatisfaction
Evoked nothing the vignette of a dream
This is content — in it motions my chords

Mute visage of this coniferous hill
As if waiting for me to unearth verity
Beckons me to stand in my ashen feel
Moribund ether an atmosphere of peat

Hypnagogia a refraction boundary
No state the image doesn't live in
Tarnished by mystery in gradient
Is my own elysian reverie reflected back to me`,
        'Triangular Hour': `Me god
Oh you know me
Where'd you come from

Me god
Oh you know me
Where'd you come from

Me god
Oh you know me
Where'd you come from

Me god
Oh you know me
Where'd you come from`,
        tabs: [
          {
            url: '/files/Tegara_-_Supermirage_rhythm_guitar_tabs.pdf',
            desc: 'Rhythm guitar tabs',
          },
        ],
      },
      {
        title: 'The Paramount Tenor',
        lyrics: `It will not enter their minds:
Death-life nourishment the paramount tenor
Treads on essence-suns alive
Windings so terrifying, of our splendor

Depth charges from the lost ones transmuting
an obtuse, solipsistic radar did not miss
In your face explodes compounded tramples

Hasn't he lost his voice already
Hasn't she masticated your decay
Isn't it us the bedrock’s pitying
Doesn’t for me total death blaze

Me!
Me!
Me!
Me!
Me!`,
        tabs: [
          {
            url: '/files/Tegara_-_The_Paramount_Tenor_rhythm_guitar.pdf',
            desc: 'Rhythm guitar tabs',
          },
          {
            url: '/files/Tegara_-_The_Paramount_Tenor_clean_and_trash_guitar.pdf',
            desc: 'Clean and trash guitar tabs',
          },
        ],
      },
      {
        title: 'Triangular Hour',
        lyrics: `Me god
Oh you know me
Where'd you come from

Me god
Oh you know me
Where'd you come from

Me god
Oh you know me
Where'd you come from

Me god
Oh you know me
Where'd you come from`,
        tabs: [
          {
            url: '/files/Tegara_-_Triangular_Hour_rhythm_guitar_tabs.pdf',
            desc: 'Rhythm guitar tabs',
          },
        ],
      },
      {
        title: 'Elysium',
        lyrics: null,
        tabs: [],
      },
    ],
    comments: null,
  },
  {
    title: 'Thousand Mile Stare',
    year: 2023,
    songs: [
      {
        title: 'Congested Tortuosa',
        lyrics: `Dissociated, unattached scanning -
A shocked, static object detection
My obliterated gaze point,
an unfocusing transparent biconvex

Ripples of thoughts trickle down inside
my Fagus sylvatica, barely detected
Unrelenting numbness,
behind which lies a Tortuosa`,
        tabs: [],
      },
      {
        title: 'Macrocosm',
        lyrics: `I exhibit non-exhibition -
I'm aligned with non-alignment
Devoid switchbacks, neural zigzags
prohibit my advertence

Bleaching bleakness
Plutonian, morose seashores
Godforsaken macrocosm radared`,
        tabs: [],
      },
      {
        title: 'Moribundity',
        lyrics: `Complete stasis of my mind
burns through itself, chews its way out
Level zero contemplation prevails
A hollow mind-shape withers

They keep popping into existence
Specks of light, particles of gleam
To be canceled as soon as they come
To instantly kill themselves off

Moribundity of my system
Inexhaustibly maintained
Anvils colliding with hemispheres
Insure the induration`,
        tabs: [],
      },
      {
        title: 'Coil To Strike',
        lyrics: `Disenthralling, disengagement
Latensified blueprints illuminated
My extreme proposition for myself
My eternal intrepidity
Brazen, activated
Magnetization

I am actuated
Cranked up, set off, convalescent
Ebullient, exuberant, riotous, excessive
I'm shaped into myself
I steamroll the blades of quiescence
Solvent for my moratorium

Mendacity dissolved
Inverted on themselves doldrums within me
My suspension, the blistering abeyance
atomized by detonative designs

Anti-prostation
coiling to strike
Potent springs of omnipotence
explode to displace defeats

In mid-air interpolate,
intercalate into fibers of self!`,
        tabs: [],
      },
    ],
    comments: null,
  },
  {
    title: 'Stochasticity',
    year: 2021,
    songs: [
      {
        title: 'Stochasticity',
        lyrics: `Incoherent thought-vomits
Droplets of acid ail
An ill and endless stream
Of odd harmonics

Was lifted up and beyond
To meet the exosphere
Dissolved by ants
Destroyed by battering crests

Generations of noise
Oceans of stochasticity
Confide in me:
Drummed to bits, these all will be; sojourn

And illuminating
With flashes of void
Fluid serialized

Feral actions determined
Fanatic cruelties for
Ourselves enclosing on
Ritualistic deconstruction

Decadence remorseless
Filling the atmosphere
Ruinous conflagration
Ending cycles of hubris

Bedrock sleeps stoic
Visions speak of ailing ground
Twisting through me
Mind's-eye sees true

Soaring in waves
Owned by the tides
Waters undeprived `,
        tabs: [
          {
            url: '/files/Tegara_-_Stochasticity_Part_I_rhythm_guitar.pdf',
            desc: 'Rhythm guitar tabs',
          },
        ],
      },
      {
        title: 'Triangular Mutineers',
        lyrics: `Imposing walls are amassing here
A plethora of stinging obelisks
Clear eye shows mere triangular mutineers
A simple synarchy of mere diminished vectors

Forms and shapes instantly reduced
Navigating contours asphyxiated
I hear unfocused arrows swimming in aether
Revealing hopeless zero-dimensional globes`,
        tabs: [
          {
            url: '/files/Tegara_-_Stochasticity_Part_II_rhythm_guitar.pdf',
            desc: 'Rhythm guitar tabs',
          },
        ],
      },
      {
        title: 'Blackened',
        lyrics: `Wretched tides of exhaustion cry
Exhaling winds breaking silence
Violently wrenching, breaking, cracking
Balance shifting into nothing

Anguished now bereft of voice
Bespeckled in agonizing splinters
Hatred gnawing, clawing, scraping
Perpetuating this looming murk

Stifling the shine, always 'mine, mine, mine'
Viewpoint internal feed gluttonous discourse
Grotesquely fattened, corpulent and bloated
Seething with desperation

Growing mighty, swollen, bloated
Depraved and blackened `,
        tabs: [
          {
            url: '/files/Tegara_-_Stochasticity_Part_III_rhythm_guitar.pdf',
            desc: 'Rhythm guitar tabs',
          },
        ],
      },
      {
        title: 'Stygian Corner',
        lyrics: `Gilded web of our designs
Incessant fallacious paradigms
Long exposed by emptied cries
Inevitably, the opposition dies

Backed into a stygian corner
Impregnates minds with horror
Hawk's sight surveys tomorrow
We live on borrowed time

Woe be to the cerebral
Calculated our descent
Our demise will be identical
Your's and the miscreant's

Struggling against oppressive tides
Creates a world
A world of fatalistic suicide `,
        tabs: [
          {
            url: '/files/Tegara_-_Stochasticity_Part_IV_rhythm_guitar.pdf',
            desc: 'Rhythm guitar tabs',
          },
        ],
      },
      {
        title: 'Dishonest Shapes',
        lyrics: `Piercing cries unobservable
A cornucopia of emptied shouts
Utterings unspeakable in the fabric
A profusion of suspended nulls

Shells of collapsing dishonest shapes
Frames disjointed, fractalizing
Shifting particulate matter dissipates
Illusions deconstructed in a blink of the eye

The mesh of infinitesimal guillotines
Sever sharp angled limbs, minimalizing
Oversaturation of fallaciousness
This plexus decongested gains air to breathe `,
        tabs: [],
      },
    ],
    comments: `Vocals and half the lyrics by Forest "Tephomab" Raible.
    
    The only release moved over from Vres catalog (2015-2022). Older project names from 2009 to 2015 included Sir Crescendo and Cres VF and releases below this are just some examples from around that era (not recommended listenings).
    `,
  },
  {
    title: 'Sixty Shades Of Naught',
    year: 2017,
    songs: [
      {
        title: 'Sixty Shades Of Naught',
        lyrics: null,
        tabs: null,
      },
    ],
    comments: `From "Invictus" LP, full song on SoundCloud.`,
  },
  {
    title: 'Untitled 2016',
    year: 2016,
    songs: [
      {
        title: 'Untitled 2016',
        lyrics: null,
        tabs: null,
      },
    ],
    comments: `From an LP that I never finished.`,
  },
  {
    title: 'Lyrae',
    year: 2015,
    songs: [
      {
        title: 'Lyrae',
        lyrics: null,
        tabs: null,
      },
    ],
    comments: `From "Vega" EP.`,
  },
  {
    title: 'Untitled 2011',
    year: 2011,
    songs: [
      {
        title: 'Untitled 2011',
        lyrics: null,
        tabs: null,
      },
    ],
    comments: `From my jazz fusion phase I guess.`,
  },
  {
    title: 'Congabongospicer Gigen',
    year: 2010,
    songs: [
      {
        title: 'Congabongospicer Gigen',
        lyrics: null,
        tabs: null,
      },
    ],
    comments: `"Gigen" was an Italian guy I played video games with.`,
  },
  {
    title: 'Untitled 2010',
    year: 2010,
    songs: [
      {
        title: 'Untitled 2010',
        lyrics: null,
        tabs: null,
      },
    ],
    comments: `Pretty sure that was EZDrummer.`,
  },
];
